import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a22b7af6 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _7e8fe675 = () => interopDefault(import('..\\pages\\submit-rebate.vue' /* webpackChunkName: "pages_submit-rebate" */))
const _c782ead2 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _06bac166 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _06c8d8e7 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _06e507e9 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _06f31f6a = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _3ba0fca7 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _6b24244f = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _a22b7af6,
    name: "error"
  }, {
    path: "/submit-rebate",
    component: _7e8fe675,
    name: "submit-rebate"
  }, {
    path: "/unlock",
    component: _c782ead2,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _06bac166,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _06c8d8e7,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _06e507e9,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _06f31f6a,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _3ba0fca7,
    name: "errors-500"
  }, {
    path: "/",
    component: _6b24244f,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
